import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
    name: 'codaltDate'
})
export class CodaltDatePipe implements PipeTransform {
    constructor(private datePipe: DatePipe) {
    }

    transform(value: Date | string | number, format: string = 'shortTime', withoutTodayPrefix: boolean = false, endValue: Date | string | number = null, timeFormat: string = 'H:mm', locale: string = 'nl-NL'): string {
        if (!value) return '';

        const date = new Date(value);
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);

        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);

        let prefix: string = null;
        let append = '';

        if (withoutTodayPrefix && date >= today && date < tomorrow) {
            prefix = ' ';
        } else if (date >= today && date < tomorrow) {
            prefix = 'Vandaag, ';
        } else if (date >= yesterday && date < today) {
            prefix = 'Gisteren, ';
        } else if (date >= tomorrow && date < new Date(tomorrow.getTime() + 86400000)) {
            prefix = 'Morgen, ';
        }
        if (endValue) {
            const dateEnd = new Date(endValue);
            if ((dateEnd.getTime() - date.getTime()) < 24 * 60 * 60 * 1000) {
                append = ' - ' + this.datePipe.transform(dateEnd, timeFormat, locale);
            } else {
                append = ' - ' + this.datePipe.transform(dateEnd, format, locale);
            }
        }
        if (prefix) {
            return prefix + this.datePipe.transform(date, timeFormat, locale) + append;
        } else {
            return this.datePipe.transform(date, format, locale) + append;
        }
    }
}
